import React from 'react';
import { Box, Flex, HStack, Text, Tag, Button, Textarea } from '@chakra-ui/react';

const SqlEditor = ({ value, onChange, isReadOnly = false, height = '320px', tokens = {}, formError, toast }) => {
  const {
    sqlEditorBg, sqlEditorBorder, sqlEditorHdrBg, sqlEditorHdrBd,
    sqlTagBg, sqlCharColor, viewSqlBodyBg, copyBtnBg, copyBtnHoverBg, sqlPlaceholder,
  } = tokens;

  return (
    <Box
      border="1px solid"
      borderColor={isReadOnly ? sqlEditorBorder : (formError ? 'red.400' : sqlEditorBorder)}
      borderRadius="md"
      overflow="hidden"
      _focusWithin={!isReadOnly ? { borderColor: 'blue.400', boxShadow: '0 0 0 1px var(--chakra-colors-blue-400)' } : {}}
    >
      {/* Editor chrome bar */}
      <Flex
        bg={sqlEditorHdrBg} px={3} py={2} align="center" justify="space-between"
        borderBottom="1px solid" borderBottomColor={sqlEditorHdrBd}
      >
        <HStack spacing={2}>
          <HStack spacing={1.5}>
            <Box w="11px" h="11px" borderRadius="full" bg="red.400" />
            <Box w="11px" h="11px" borderRadius="full" bg="yellow.400" />
            <Box w="11px" h="11px" borderRadius="full" bg="green.400" />
          </HStack>
          <Text fontSize="xs" color="gray.400" fontFamily="mono" ml={1}>
            {isReadOnly ? 'SQL Query (Read-only)' : 'SQL Query Editor'}
          </Text>
        </HStack>
        <HStack spacing={2}>
          <Tag size="sm" bg={sqlTagBg} color="white" fontSize="10px" fontWeight="bold" borderRadius="sm">SQL</Tag>
          {value && (
            <Text fontSize="11px" color={sqlCharColor} fontFamily="mono">{value.length.toLocaleString()} chars</Text>
          )}
          {isReadOnly && value && (
            <Button
              size="xs" variant="ghost"
              bg={copyBtnBg} color="gray.300"
              _hover={{ bg: copyBtnHoverBg, color: 'white' }}
              onClick={() => {
                navigator.clipboard?.writeText(value);
                toast({ title: 'Copied!', status: 'success', duration: 2000, isClosable: true });
              }}
              fontFamily="mono" fontSize="11px"
            >Copy</Button>
          )}
        </HStack>
      </Flex>

      {/* Editor body */}
      <Textarea
        value={value}
        onChange={e => { if (!isReadOnly && onChange) onChange(e.target.value); }}
        readOnly={isReadOnly}
        placeholder={!isReadOnly ? "SELECT\n  column1,\n  column2\nFROM\n  your_table\nWHERE\n  condition = 'value';" : undefined}
        bg={isReadOnly ? viewSqlBodyBg : sqlEditorBg}
        color="green.300"
        fontFamily="'Courier New', Consolas, Monaco, monospace"
        fontSize="13px"
        lineHeight="1.65"
        border="none"
        borderRadius="0"
        resize="none"
        h={height}
        overflowY="auto"
        spellCheck={false}
        whiteSpace="pre"
        _placeholder={{ color: sqlPlaceholder, fontStyle: 'italic' }}
        _focus={{ boxShadow: 'none' }}
        _readOnly={{ cursor: 'default', userSelect: 'all' }}
        sx={{
          caretColor: '#68D391',
          '&::-webkit-scrollbar':             { width: '8px', height: '8px' },
          '&::-webkit-scrollbar-track':       { background: 'var(--chakra-colors-gray-900)' },
          '&::-webkit-scrollbar-thumb':       { background: 'var(--chakra-colors-gray-600)', borderRadius: '4px' },
          '&::-webkit-scrollbar-thumb:hover': { background: 'var(--chakra-colors-gray-500)' },
        }}
      />
    </Box>
  );
};

export default SqlEditor;